import EmailReset from './EmailReset';

export default EmailReset;



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/subComponents/EmailReset/index.jsx